import React from 'react';
import { CardsList } from 'features/my-gift-cards/components/CardsList';

interface MyGiftCardsListPageProps {}

export const MyGiftCardsListPage: React.FC<MyGiftCardsListPageProps> = () => {
  return <CardsList />;
};
